"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccount = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var _useAuthenticated = require("./useAuthenticated");

var _api = require("../api");

var _utility = require("../utility");

var _context = require("../context");

var _types = require("../types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useAccount = function useAccount() {
  var isAuthenticated = (0, _useAuthenticated.useAuthenticated)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var context = _react["default"].useContext(_context.AuthContext);
  /* istanbul ignore next */


  if (!context) {
    throw new Error('useAccount must be used within an AuthProvider');
  }

  var dispatch = context.dispatch;
  return (0, _reactQuery.useQuery)(_types.QueryKeys.Account, function () {
    return (0, _api.fetchAccount)();
  }, {
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 20 * 60000,
    onError: function onError(error) {
      var _a;

      if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        dispatch({
          type: _context.AuthActions.LOGOUT
        });
        (0, _utility.removeToken)();
        queryClient.clear();
      }
    }
  });
};

exports.useAccount = useAccount;